// Soft, in-character lines Mochi murmurs when her Hunger Meter drops a stage
// (e.g. Stuffed → Full → Content → Peckish → Hungry). The decay is the
// existing 48h-without-feeding behaviour — these phrases are purely the
// emotional companion side of "watching her get a little hungry over time."
//
// Per the Personality Bible (see PRD §10):
//   - No blame, no "should", no reference to missed tasks
//   - Lowercase + ellipses for warmth
//   - One single emoji at most
//   - Never a banner, never a warning
//
// Used by `useHungerDrop` — fires at most once per stage drop as a sonner
// toast.
export const HUNGER_DROP_PHRASES = [
    "mmm, getting a little hungry over here 🍙 no rush though",
    "rice ball thoughts intensifying...",
    "tummy mood: starting to murmur 🍡",
    "could go for a snack… whenever you're free 🍙",
];

export function pickHungerDropPhrase() {
    return HUNGER_DROP_PHRASES[Math.floor(Math.random() * HUNGER_DROP_PHRASES.length)];
}
